import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Card from "../../../componentes/contenedores/Card";
import SmallBox from "../../../componentes/contenedores/SmallBox";
import Page from "../../../componentes/plantilla/Page";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";

const AnalisisPage = () => {
    const { usuario } = useContextUsuario();
    const location = useLocation();
    const rutaAnalisisBase = "/app/admin/analisis";
    const acceso = (usuario?.accesos || []).find(
        (a) => a.ruta.replace(/\/+$/, "") === rutaAnalisisBase
    );
    const permisos = acceso?.permisos ? acceso.permisos.split(",").map(p => p.trim()) : [];
    const esRutaPrincipal = location.pathname.replace(/\/+$/, "") === rutaAnalisisBase;

    const datos = {
        titulo: {
            titulo: "Opciones de Análisis",
            url: "/app/admin/analisis/",
            tituloUrl: "Panel de Control",
            nombreUrl: "Inicio",
        },
    };

    const subtitulo = "Gráficas y Estadísticas";

    if (!esRutaPrincipal) {
        return <Outlet />;
    }

    return (
        <Page datos={datos}>
            <Card>
                <div className="row">
                    {permisos.includes("Ventas") && (
                        <SmallBox
                            color="primary"
                            value="Ventas"
                            label={subtitulo}
                            icon="fas fa-chart-line"
                            link={`${rutaAnalisisBase}/ventas`}
                        />
                    )}

                    {permisos.includes("Clientes") && (
                        <SmallBox
                            color="info"
                            value="Clientes"
                            label={subtitulo}
                            icon="fas fa-user-friends"
                            link={`${rutaAnalisisBase}/clientes`}
                        />
                    )}

                    {permisos.includes("Compras") && (
                        <SmallBox
                            color="warning"
                            value="Compras"
                            label={subtitulo}
                            icon="fas fa-shopping-basket"
                            link={`${rutaAnalisisBase}/compras`}
                        />
                    )}

                    {permisos.includes("Inventarios") && (
                        <SmallBox
                            color="indigo"
                            value="Inventarios"
                            label={subtitulo}
                            icon="fas fa-warehouse"
                            link={`${rutaAnalisisBase}/inventarios`}
                        />
                    )}

                    {permisos.includes("Productos") && (
                        <SmallBox
                            color="success"
                            value="Productos"
                            label={subtitulo}
                            icon="fas fa-boxes"
                            link={`${rutaAnalisisBase}/productos`}
                        />
                    )}

                    {permisos.includes("Empleados") && (
                        <SmallBox
                            color="danger"
                            value="Empleados"
                            label={subtitulo}
                            icon="fas fa-users-cog"
                            link={`${rutaAnalisisBase}/empleados`}
                        />
                    )}

                    {permisos.includes("Cajas") && (
                        <SmallBox
                            color="dark"
                            value="Cajas"
                            label={subtitulo}
                            icon="fas fa-cash-register"
                            link={`${rutaAnalisisBase}/cajas`}
                        />
                    )}
                </div>
            </Card>
        </Page>
    );
};

export default AnalisisPage;